import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/domains';
export var AttachmentFile = /*#__PURE__*/function (_ValueObject) {
  _inherits(AttachmentFile, _ValueObject);

  var _super = _createSuper(AttachmentFile);

  function AttachmentFile() {
    _classCallCheck(this, AttachmentFile);

    return _super.apply(this, arguments);
  }

  _createClass(AttachmentFile, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "fileName",
    get: function get() {
      return this.props.fileName;
    }
  }, {
    key: "fileMimeType",
    get: function get() {
      return this.props.fileMimeType;
    }
  }, {
    key: "url",
    get: function get() {
      return this.props.url;
    }
  }, {
    key: "fileSize",
    get: function get() {
      return this.props.fileSize;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardResult = Guard.againstNullOrUndefinedBulk([{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.fileName,
        argumentName: 'FileName'
      }, {
        argument: props.fileMimeType,
        argumentName: 'FileMimeType'
      }, {
        argument: props.url,
        argumentName: 'Url'
      }, {
        argument: props.fileSize,
        argumentName: 'FileSize'
      }]);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid attachment file props');
      }

      if (props.fileSize < 0) {
        return Result.fail('File size cannot be negative');
      }

      var fileNameGuard = Guard.againstStringNullOrEmpty(props.fileName, 'FileName');

      if (!fileNameGuard.succeeded) {
        var _fileNameGuard$messag;

        return Result.fail((_fileNameGuard$messag = fileNameGuard.message) !== null && _fileNameGuard$messag !== void 0 ? _fileNameGuard$messag : 'File name cannot be empty');
      }

      var urlGuard = Guard.againstStringNullOrEmpty(props.url, 'Url');

      if (!urlGuard.succeeded) {
        var _urlGuard$message;

        return Result.fail((_urlGuard$message = urlGuard.message) !== null && _urlGuard$message !== void 0 ? _urlGuard$message : 'URL cannot be empty');
      }

      return Result.ok(new AttachmentFile(props));
    }
  }]);

  return AttachmentFile;
}(ValueObject);